import { render, staticRenderFns } from "./courseScheduleManageVip.vue?vue&type=template&id=b5047842&scoped=true"
import script from "./courseScheduleManageVip.vue?vue&type=script&lang=js"
export * from "./courseScheduleManageVip.vue?vue&type=script&lang=js"
import style0 from "./courseScheduleManageVip.vue?vue&type=style&index=0&id=b5047842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5047842",
  null
  
)

export default component.exports